<!-- Component that implements a list of documents -->
<template lang="html">
  <div>
    <v-data-table
    :headers="headers"
    :items="listaParcerias"
    :search="search"
    :no-data-text="'Este projeto não possui parcerias.'"
    must-sort
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :items-per-page="itemsPerPage"
    :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    >
      <template v-slot:item.opcoes="props">
        <v-btn color="primary" text icon @click="excluirParceria(props.item.id)" ><v-icon>delete</v-icon></v-btn>
      </template>
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaParcerias.length }} parcerias
      </template>
    </v-data-table>
    <br><br>
    <v-divider></v-divider>
    <v-card-actions v-if="projeto.funcao != null && projeto.funcao.item === 1">
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="toCriarParceria" >Nova Parceria</v-btn>
      <v-btn color="primary" text @click="toAvancar" >Avançar</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'projeto'],
  data: () => ({
    listaParcerias: [],
    dates: dates,
    search: null,
    sortBy: 'funcao.descricao',
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Nome do parceiro', align: 'left', value: 'descricao' },
      { text: 'Detalhamento', align: 'left', value: 'detalhamento' },
      { text: 'Excluir', align: 'left', value: 'opcoes' }
    ]
  }),
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    toCriarParceria: function () {
      this.$router.push({ name: 'NovaParceria', params: {idProjeto: this.idProjeto} })
    },
    toAvancar: function () {
      this.$router.push({ name: 'EditarAbrangencia', params: {idProjeto: this.projeto.idProjeto} })
    },
    carregaParcerias: function (idProjeto) {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parcerias.' })
      projetos.getParceriasDoProjeto(this.idProjeto)
      .then(response => {
        this.listaParcerias = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando parcerias.' })
      })
    },
    excluirParceria: function (idParceria) {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo parceria.' })
      projetos.deleteParceria(this.idProjeto, idParceria)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        this.carregaParcerias(this.idProjeto)
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo parceria.' })
      })
    }
  },
  mounted () {
    this.carregaParcerias(this.idProjeto)
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'tooltip': ToolTip
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// projeto-editar-parcerias.vue?e3acf9b2